<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Fila de E-mails</h1>

    <SGPPaginacaoComponent 
      v-if="listaDeEmails.length"
      :paginacao="paginacao" 
      @sgpAtualizarPaginacao="realizarPaginacao"
      :key="paginacao?.current_page"
    >
      <SGPTabelaAvancadaComponent
        :colunas="colunas"
        :dados="listaDeEmails"
        :key="JSON.stringify(listaDeEmails)"
        :usuarioPodeEditar="false"
        :usuarioPodeExcluir="false"
        selecionarColunas
        :filtroText="true"
      >
        <template v-slot:item.acoes="{ item }">
          <button 
            class="v-btn v-btn--text v-btn--icon theme--light v-size--small"
            @click="visualizarCorpo(item)"
            title="Visualizar corpo do e-mail"
          >
            <SGPIconComponent icon="mdi-eye" />
          </button>
        </template>
      </SGPTabelaAvancadaComponent>
    </SGPPaginacaoComponent>

    <SGPAlertaComponent v-else/>

    <SGPModalComponent
      v-if="abrirModal"
      tamanho="lg"
      titulo="Visualizar E-mail"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <VisualizarEmailComponent
        :email="emailSelecionado"
      />
    </SGPModalComponent>

    <SGPLoadingComponent v-if="loadingEmails"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import VisualizarEmailComponent from '../components/VisualizarEmailComponent.vue'

export default {
  name: 'PcoEmailsQueuePage',
  
  components: {
    VisualizarEmailComponent
  },

  data () {
    return {
      abrirModal: false,
      emailSelecionado: {}
    }
  },

  created () {
    this.listarEmails(this.montarParametros())
  },

  computed: {
    ...mapGetters('pcoEmailsQueue', [
      'listaDeEmails',
      'loadingEmails',
      'paginacao'
    ]),

    colunas () {
      return [
        { key: 'acoes', label: 'Ações', sortable: false, width: '100' },
        { key: 'from', label: 'De', sortable: true },
        { key: 'to', label: 'Para', sortable: true },
        { key: 'enfileirado', label: 'Enfileirado', sortable: true },
        { key: 'tentativas', label: 'Tentativas', sortable: true },
        { key: 'sended_at', label: 'Enviado em', sortable: true }
      ]
    }
  },

  methods: {
    ...mapActions('pcoEmailsQueue', [
      'listarEmails'
    ]),

    montarParametros(extra = {}) {
      return {
        per_page: this.paginacao?.per_page || 100,
        page: this.paginacao?.current_page || 1,
        current_page: this.paginacao?.current_page || 1,
        ...extra
      }
    },

    realizarPaginacao(paginate) {
      const current = paginate.current_page || 1
      const perPage = paginate.per_page || this.paginacao?.per_page || 100
      this.listarEmails(
        this.montarParametros({
          page: current,
          current_page: current,
          per_page: perPage
        })
      )
    },

    visualizarCorpo (item) {
      this.emailSelecionado = item
      this.abrirModal = true
    },

    fecharModal () {
      this.abrirModal = false
    }
  }
}
</script>
